import { Container } from "@mui/material";
import React from "react";
import Navigation from "../../components/Navigation";
const Home = () => {
  return (
    <Container>
      <Navigation />
      <br />
      WELCOME HOME PAGE
    </Container>
  );
};

export default Home;
